import { Routes } from '@angular/router';
import { authGuard, canViewGuard } from './auth/auth-guard';

const appName = ' - Eve Intelligence';
export const routes: Routes = [
  {
    path: '',
    title: 'Environmental Verification',
    loadComponent: () =>
      import('./features/landing/landing').then((m) => m.LandingComponent),
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./features/home/home').then((m) => m.HomeComponent),
    canActivate: [authGuard],
    title: 'Main' + appName,
    pathMatch: 'full',
    data: { reuseKey: 'dashboard' },
  },
  {
    path: 'view/:dashboardid',
    title: 'Dashboard' + appName,
    loadComponent: () =>
      import('./features/home/home').then((m) => m.HomeComponent),
    canActivate: [authGuard],
    data: { reuseKey: 'dashboard' },
  },
  {
    path: 'login',
    title: 'Login' + appName,
    loadComponent: () => import('./auth/login/login').then((m) => m.Login),
  },
  {
    path: 'logout',
    loadComponent: () => import('./auth/logout/logout').then((m) => m.Logout),
  },
  {
    path: 'forgotpassword',
    title: 'Forgot Password' + appName,
    loadComponent: () =>
      import('./auth/forgotpassword/forgotpassword').then(
        (m) => m.Forgotpassword,
      ),
  },
  {
    path: 'changepassword',
    title: 'Change Password' + appName,
    loadComponent: () =>
      import('./auth/changepassword/changepassword').then(
        (m) => m.Changepassword,
      ),
  },

  {
    path: 'master-data',
    loadComponent: () =>
      import('./features/master-data/master-data').then(
        (m) => m.MasterDataComponent,
      ),
    children: [
      {
        path: 'asset',
        title: 'Asset' + appName,
        loadChildren: () =>
          import('./features/master-data/asset-management/asset-management.routes').then(
            (m) => m.routes,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'asset', flag: 'canview' },
      },
      {
        path: 'ownership',
        title: 'Ownership' + appName,
        loadComponent: () =>
          import('./features/master-data/ownership/ownership').then(
            (m) => m.OwnershipComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'ownership', flag: 'canview' },
      },
      {
        path: 'waste-contract',
        title: 'Waste Contract' + appName,
        loadComponent: () =>
          import('./features/master-data/waste-contract/waste-contract').then(
            (m) => m.WasteContractComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'wastecontract', flag: 'canview' },
      },
      {
        path: 'waste-contractor',
        title: 'Waste Contractor' + appName,
        loadComponent: () =>
          import('./features/master-data/waste-contractor/waste-contractor').then(
            (m) => m.WasteContractorComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'wastecontractor', flag: 'canview' },
      },

      {
        path: 'equipment',
        title: 'Equipment' + appName,
        loadComponent: () =>
          import('./features/master-data/equipment/equipment').then(
            (m) => m.EquipmentComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'equipment', flag: 'canview' },
      },
      {
        path: 'custom-density',
        title: 'Custom Density' + appName,
        loadComponent: () =>
          import('./features/master-data/custom-density/custom-density').then(
            (m) => m.CustomDensityComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'customdensity', flag: 'canview' },
      },
      {
        path: 'standard-density',
        title: 'Standard Density' + appName,
        loadComponent: () =>
          import('./features/master-data/standard-density/standard-density.component').then(
            (m) => m.StandardDensityComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'standarddensity', flag: 'canview' },
      },
      {
        path: 'material-stream-input',
        title: 'Material Stream Input' + appName,
        loadComponent: () =>
          import('./features/master-data/material-stream-input/material-stream-input').then(
            (m) => m.MaterialStreamInputComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'msi', flag: 'canview' },
      },
      {
        path: 'ownership-entity',
        title: 'Ownership Entity' + appName,
        loadComponent: () =>
          import('./features/master-data/ownership-entity/ownership-entity').then(
            (m) => m.OwnershipEntityComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'ownershipentity', flag: 'canview' },
      },

      {
        path: 'proc-facility-profiling',
        title: 'Processing Facility Outcome' + appName,
        loadComponent: () =>
          import('./features/master-data/proc-facility-profiling/proc-facility-profiling').then(
            (m) => m.ProcFacilityProfilingComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'profilingpfo', flag: 'canview' },
      },
      {
        path: 'mso-profiling',
        title: 'Material Stream Output Profiling' + appName,
        loadComponent: () =>
          import('./features/master-data/mso-profiling/mso-profiling').then(
            (m) => m.MsoProfilingComponent,
          ),
        canActivate: [canViewGuard],
        data: { entity: 'profilingmso', flag: 'canview' },
      },
      {
        path: 'profiling',
        title: 'Profiling' + appName,
        loadComponent: () =>
          import('./features/master-data/profiling/profiling').then(
            (m) => m.ProfilingComponent,
          ),
      },
      {
        path: 'proc-facility',
        title: 'Proc Facility' + appName,
        loadComponent: () =>
          import('./features/master-data/proc-facility/proc-facility').then(
            (m) => m.ProcFacilityComponent,
          ),
      },
      {
        path: 'profile',
        title: 'Profiles' + appName,
        loadComponent: () =>
          import('./features/master-data/profile/profile').then(
            (m) => m.ProfileComponent,
          ),
      },

      { path: '', redirectTo: 'asset', pathMatch: 'full' }, // Default child route
    ],
  },
  {
    path: 'waste-data/:uploadtype',
    title: 'Waste Data Upload' + appName,
    loadComponent: () =>
      import('./features/waste-data/waste-data').then(
        (m) => m.WasteDataComponent,
      ),
    canActivate: [authGuard, canViewGuard],
    data: { entity: 'uploaddata', flag: 'canview' },
  },

  {
    path: 'review-data',
    children: [
      {
        path: 'wastedata-review',
        title: 'Waste Data' + appName,
        loadComponent: () =>
          import('./features/review-data/wastedata-review/wastedata-review')
            .then(m => m.WastedataReviewComponent),
        canActivate: [authGuard, canViewGuard],
        data: { entity: 'rna-wastedatareview', flag: 'canview' },
      },
      {
        path: 'open-periods',
        title: 'Open Periods' + appName,
        loadComponent: () =>
          import('./features/review-data/open-periods/open-periods').then(
            (m) => m.OpenPeriodsComponent,
          ),
        canActivate: [authGuard, canViewGuard],
        data: { entity: 'rna-openperiods', flag: 'canview' },
      },
      {
        path: 'lock-periods',
        title: 'Lock Periods' + appName,
        loadComponent: () =>
          import('./features/review-data/lock-periods/lock-periods').then(
            (m) => m.LockPeriodsComponent,
          ),
        canActivate: [authGuard, canViewGuard],
        data: { entity: 'rna-lockperiods', flag: 'canview' },
      },
      { path: '', redirectTo: 'open-periods', pathMatch: 'full' },
    ],
  },

  {
    path: 'reports/login-report',
    title: 'Login History Report' + appName,
    loadComponent: () =>
      import('./features/reports/login-report/login-report')
        .then((m) => m.LoginReportComponent),
    canActivate: [authGuard, canViewGuard],
    data: { entity: 'loginreport', flag: 'canview' },
  },

  {
    path: 'reports/audit-logs',
    title: 'Audit Logs' + appName,
    loadComponent: () =>
      import('./features/reports/audit-logs/audit-logs')
        .then((m) => m.AuditLogsComponent),
    canActivate: [authGuard, canViewGuard],
    data: { entity: 'auditlogs', flag: 'canview' },
  },

  {
    path: 'audit-support',
    title: 'Audit Support',
    loadComponent: () =>
      import('./features/audit-support/audit-support').then(
        (m) => m.AuditSupportComponent,
      ),
  },

  {
    path: 'hub',
    title: 'Home — Eve Intelligence',
    loadComponent: () => import('./features/hub/hub').then((m) => m.HubComponent),
    canActivate: [authGuard],
  },

  { path: '**', redirectTo: '' },
];
